export default __webpack_public_path__ + "static/media/drop-down.e97f658e.svg";